module.exports = __webpack_public_path__ + "img/saddle-cloths-7.fda5a22d.svg";